import React, { useEffect, useState } from 'react';
import { bool, string } from 'prop-types';
import { loadEvent } from '../../publisher';
import { getPaymentEstimatorDetails } from '../../utils';
import { cardImageUrl } from '../../constants';
import { ApplyNowModal } from '../apply-now-modal/apply-now-modal.component';
import './offers-for-you.style.scss';

export const OffersForYou = ({ isMobile, price, isAppliance }) => {
  const [paymentEstimatorDetails, setPaymentEstimatorDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const displayIntroOffer = price < 299;

  function updatePaymentEstimatorDetails() {
    setPaymentEstimatorDetails(getPaymentEstimatorDetails(price, isMobile, isAppliance));
  }

  useEffect(() => {
    loadEvent('plcc-est');
    updatePaymentEstimatorDetails();
  }, [price]);

  if (!paymentEstimatorDetails) {
    return null;
  }

  const {
    applyNowUrl, displayPrice, promotionTerm,
  } = paymentEstimatorDetails;

  const paymentEstimatorText = () => {
    return (
      <div className="offers-text">
        <span className="u__bold">Pay ${displayPrice}.00 per mo.* </span>suggested
        <br />
        payments w/ <span className="u__bold">{promotionTerm}-mo. </span>financing*
      </div>
    );
  };

  const introOfferText = () => {
    return (
      <div className="offers-text">
        <span className="u__bold">GET UP TO $100 OFF* </span>on
        <br />
        your qualifying purchase.
      </div>
    );
  };

  return (
    <>
      {showModal
        && (
          <ApplyNowModal
            applyNowUrl={applyNowUrl}
            closeModal={closeModal}
            price={price}
            isMobile={isMobile}
            monthlyPayment={displayPrice}
            promotionTerm={promotionTerm}
          />
        )}
      <div className="buybox-credit-promo-message offers-wrapper">
        <span className="offer-label u__bold">Offers for you</span>
        <div className="offers-content">
          <div>
            <img
              src={cardImageUrl}
              role="presentation"
              className="offers-card-image"
              alt=""
            />
          </div>
          <div className="offers-flex">
            {displayIntroOffer && introOfferText()}
            {!displayIntroOffer && paymentEstimatorText()}
            <button
              className="u__default-link u--paddingRight"
              onClick={openModal}
              type="button"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

OffersForYou.displayName = 'OffersForYou';

OffersForYou.propTypes = {
  isMobile: bool,
  price: string.isRequired,
  isAppliance: bool
};

OffersForYou.defaultProps = {
  isMobile: false,
  isAppliance: false
};
